import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Geosuggest from '@ubilabs/react-geosuggest';
import DocumentUpload from '../../DocumentUpload';
import notAvailable from '../../../../assets/images/not-available.png';
import greenCheck from '../../../../assets/images/green-check.png';
import clock from '../../../../assets/images/icons/clock.svg';
import suitcase from '../../../../assets/images/icons/suitcaseGray.svg';
import mapPin from '../../../../assets/images/icons/map-pin.png';
import airplane from '../../../../assets/images/icons/airplaneGray.svg';
import clockPerson from '../../../../assets/images/icons/clockPerson.svg';
import dollarSign from '../../../../assets/images/icons/dollarGray.svg';
import blueInfoIcon from '../../../../assets/images/icons/blue-info-icon.svg';
import redWarningIcon from '../../../../assets/images/icons/red-warning-icon.svg';
import SearchIcon from '../../../../assets/images/search-icon.svg';

class InterestDetails extends Component {
  constructor(props) {
    super(props);

    this.tagTypes = {
      area_of_expertises: 'Functional areas',
      therapeutic_areas: 'Therapeutic areas',
      therapies: 'Product Technologies',
      development_phases: 'Development phases',
      disease_codes: 'Disease codes',
      regulatory_pathways: 'Regulatory pathways',
      degrees: 'Education',
      accreditations: 'Certifications',
      languages: 'Languages',
    };

    this.state = {
    };
  }

  requiredExpertisePresent() {
    const { project } = this.props;

    return Object
      .keys(this.tagTypes)
      .reduce((agg, type) => agg.concat(project?.missing_priority_tags[type] || []).concat(
        project?.matching_priority_tags[type] || [],
      ), []).length;
  }

  preferredExpertisePresent() {
    const { project } = this.props;

    return Object
      .keys(this.tagTypes)
      .reduce((agg, type) => agg.concat(project?.missing_preferred_tags[type] || []).concat(
        project?.matching_preferred_tags[type] || [],
      ), []).length;
  }

  officeLocationText() {
    const { project } = this.props;
    let projectLocation = '';

    switch (project?.work_location.toLowerCase()) {
      case 'office':
        projectLocation += 'In Office';
        if (project?.office_days) {
          projectLocation = `${projectLocation} at least ${project?.office_days} days / week`;
        }
        if (project?.office_location) {
          projectLocation += ` at ${project?.office_location}`;
        }
        return projectLocation;

      case 'remote':
        return project?.remote_preferred_location
          ? `Remote, ideally from ${project?.remote_preferred_location}`
          : 'Remote';

      case 'hybrid':
        projectLocation += 'Hybrid';
        if (project?.office_days) {
          projectLocation = `${projectLocation}, in office ${project?.office_days} days / week `;
        }
        if (project?.office_location) {
          projectLocation += ` at ${project?.office_location}`;
        }
        return projectLocation;

      case 'both':
        return `Office and remote. At least ${project?.office_days} days in the office (${project?.office_location}).`;
      case 'not sure':
        return 'Workplace Type - Unsure';
      default:
        return 'Work preference';
    }
  }

  renderProjectTags(priority, tagType, label) {
    const { project } = this.props;
    const matchingTags = priority ? project?.matching_priority_tags[tagType]
      : project?.matching_preferred_tags[tagType];
    const missingTags = priority ? project?.missing_priority_tags[tagType]
      : project?.missing_preferred_tags[tagType];

    if (!(matchingTags + missingTags).length) return null;

    return (
      <Fragment key={`${label}-tags`}>
        <h6 className="expertise-tag-header">{label}</h6>
        {matchingTags.length
          ? (
            <Fragment key={`${label}-matching-tags`}>
              <img className="green-check" src={greenCheck} alt="Matched expertise" />
              {matchingTags.map((tag) => <span key={tag.name} className="badge small matching-tag">{tag.name}</span>)}
            </Fragment>
          )
          : ''}
        {missingTags.length
          ? (
            <Fragment key={`${label}-missing-tags`}>
              {
              priority
                ? <img className="not-available" src={notAvailable} alt="Missing expertise" />
                : ''
            }
              {missingTags.map((tag) => <span key={tag.name} className={`badge small ${priority ? 'missing-tag' : 'normal-tag'}`}>{tag.name}</span>)}
            </Fragment>
          )
          : ''}
      </Fragment>
    );
  }

  renderWorkAuthorization() {
    const {
      project, handleToggleCheckbox, submitAttempted, submitted, checkboxes,
    } = this.props;

    if (!project?.us_work_authorization_required) return null;
    return (
      <Fragment>
        <h5 className="uppercase-demibold mt-4">Work Authorization</h5>
        <div className="body-text-2 mt-3 mb-3">
          Will you now or in the future require sponsorship to work within the United States?
        </div>
        { submitted
          ? '✅ No'
          : (
            <div className="body-text-2 mb-3 ">
              <label
                htmlFor="work-authorization-checkbox-yes"
                className="work-authorization-checkbox-label"
              >
                <input
                  type="radio"
                  id="work-authorization-checkbox-yes"
                  name="work-authorization-checkbox"
                  value="Yes"
                  onChange={handleToggleCheckbox('work_authorization', false)}
                />
                Yes
              </label>
              <label
                htmlFor="work-authorization-checkbox-no"
                className="work-authorization-checkbox-label ms-2"
              >
                <input
                  type="radio"
                  id="work-authorization-checkbox-no"
                  name="work-authorization-checkbox"
                  value="No"
                  onChange={handleToggleCheckbox('work_authorization', true)}
                />
                No
              </label>
              {(submitAttempted && !checkboxes.work_authorization)
                ? (
                  <div className="warning-text">
                    Work authorization is required before continuing to the next step
                  </div>
                ) : ''}
            </div>
          )}
      </Fragment>
    );
  }

  renderHourlyRateSection() {
    const {
      project, handleTextChange, submitAttempted, repView, requestedHourlyRate,
    } = this.props;

    return (
      <Fragment>
        <h5 className="uppercase-demibold mt-4">Hourly Rate</h5>
        <div className="body-text-2 mt-3 mb-3">
          Considering the scope of the project, seniority and responsibilities below,
          what hourly rate range would you consider for this project?
        </div>
        {this.renderProjectTags(false, 'levels', 'Seniority')}
        <h6>Role Responsibilities</h6>
        <ul>{ project?.responsibilities.map((resp) => <li key={resp}>{resp}</li>) }</ul>
        <h6>Your preferred hourly rate (in USD)</h6>
        <div className="hourly-rates-container">
          <div className="requested-hourly-rate me-2">
            <img src={dollarSign} alt="Hourly rate in dollars" />
            <input
              id="requested-hourly-rate"
              type="text"
              onChange={handleTextChange('requestedHourlyRate')}
              pattern="[0-9]+"
              value={requestedHourlyRate}
              readOnly={repView}
            />
          </div>
        </div>
        {submitAttempted && !requestedHourlyRate
          && (
          <div className="warning-text">
            Please enter your preferred hourly rate.
          </div>
          )}
        {submitAttempted && !requestedHourlyRate.match(/^[0-9]+$/)
          && (
          <div className="warning-text">
            Please enter a whole number as an hourly rate.
          </div>
          )}
        {project?.consultant_take_home_minimum && project?.consultant_take_home_maximum
          ? (
            <div className="hourly-rate-info">
              <img src={blueInfoIcon} alt="Info" />
              A typical range for similar roles is
              <span className="demibold ms-2">
                $
                {project?.consultant_take_home_minimum}
                {' '}
                - $
                {project?.consultant_take_home_maximum }
              </span>
              , depending on experience
            </div>
          )
          : ''}
      </Fragment>
    );
  }

  renderTaxReporting() {
    const {
      submitted, handleToggleCheckbox, submitAttempted, checkboxes,
    } = this.props;

    return (
      <Fragment>
        <h5 className="uppercase-demibold mt-4">Tax reporting</h5>
        <div className="body-text-2 mt-3 mb-3">
          Consultants for this role are responsible for their own federal payroll taxes,
          also known as self-employment tax. Clora will provide you with a
          &nbsp;
          <span className="demibold">1099</span>
          .
        </div>
        { submitted
          ? '✅ Accepted'
          : (
            <label htmlFor="tax-reporting-checkbox" className="tax-reporting-checkbox-label">
              <input
                type="checkbox"
                id="tax-reporting-checkbox"
                onChange={handleToggleCheckbox('tax_reporting')}
              />
              I understand
            </label>
          )}
        { submitAttempted && !checkboxes.tax_reporting
          && (
          <div className="warning-text">
            Please acknowledge before continuing to the next step
          </div>
          )}
      </Fragment>
    );
  }

  renderMissingTagWarning() {
    const { profilePath } = this.props;

    return (
      <div className="missing-expertise-warning">
        <img src={redWarningIcon} alt="Warning" />

        <div className="text">
          <div className="heading">
            You must have the required expertise in order to submit this application.
          </div>
          <br />
          <a href={profilePath} className="application-add-expertise">Add expertise</a>
        </div>
      </div>
    );
  }

  render() {
    const {
      project, uploadResumeUrl, csrfToken, resume, checkboxes, submitted,
      missingRequiredExpertise, handleToggleCheckbox, handleUpdateResume,
      submitAttempted, repView, handleTextChange, location, openToRelocation,
      isHybridOrInOffice, handleOpenToggleCheckbox,
    } = this.props;

    return (
      <div className="style-guide start-application p-2 px-md-2 py-md-3">
        <h2>
          {repView ? `${project?.consultant_name} - ` : 'Submit an '}
          Application for
          {' '}
          {project?.name}
        </h2>

        <h5 className="uppercase-demibold mt-3 mb-2">Your Resume</h5>
        <div className="body-text-2 mt-3 mb-2">
          This resume will be included with your application and shared with clients.
        </div>
        { repView
          ? (
            <a href={resume.document_url} target="_blank" rel="noreferrer">
              {resume.document_file_name}
            </a>
          )
          : (
            <DocumentUpload
              location="Consultant Interest"
              buttonStyle="button"
              prompt="Upload Resume"
              uploadDocumentUrl={uploadResumeUrl}
              document={resume}
              csrfToken={csrfToken}
              documentType="resume"
              handleAfterUpload={(r) => handleUpdateResume(r)}
              skipParsing
            />
          )}
        { submitAttempted && !resume
          && (
          <div className="warning-text">
            Please upload a resume
          </div>
          )}

        { this.requiredExpertisePresent()
          ? (
            <Fragment>
              <h5 className="uppercase-demibold mt-4">Required expertise</h5>
              <div className="body-text-2 mt-3 mb-2">
                This project requires candidates to have the following expertise
                as the minimum requirements for consideration.
              </div>
              { Object.keys(this.tagTypes).map((type) => (
                this.renderProjectTags(true, type, this.tagTypes[type])
              )) }
            </Fragment>
          )
          : ''}
        { missingRequiredExpertise ? this.renderMissingTagWarning() : '' }
        { this.preferredExpertisePresent()
          ? (
            <Fragment>
              <h5 className="uppercase-demibold mt-4">Preferred expertise</h5>
              <div className="body-text-2 mt-3 mb-3">
                The client would prefer to see these skill sets, but they are not required.
                Let’s check these optional criteria against your expertise.
              </div>
              { Object.keys(this.tagTypes).map((type) => (
                this.renderProjectTags(false, type, this.tagTypes[type])
              )) }
            </Fragment>
          )
          : ''}
        <h5 className="uppercase-demibold mt-4">
          { project?.employment_type === 'full_time' ? 'Logistics' : 'Availability' }
        </h5>
        <div className="body-text-2 mt-3 mb-3">
          The client requires candidates who can meet the following requirements:
        </div>
        <div className="body-text-2 mt-8">
          { project?.approximate_start_date_local
            ? (
              <div className="availability-text">
                <img src={suitcase} alt="Suitcase" />
                {`Scheduled to start ${project?.approximate_start_date_local}`}
              </div>
            ) : ''}
        </div>
        { project?.avg_time_required_range && project?.employment_type === 'consulting'
          ? (
            <div className="availability-text">
              <img src={clock} alt="Hours required per week" />
              {`${project?.avg_time_required_range} hours / wk`}
            </div>
          ) : ''}
        { project?.duration_range && project?.employment_type === 'consulting'
          ? (
            <div className="availability-text duration">
              <img src={clockPerson} alt="Duration of project" />
              {project?.duration_range === 1 ? `${project?.duration_range} month` : `${project?.duration_range} months`}
            </div>
          ) : ''}
        { project?.work_location
          ? (
            <div className="availability-text">
              <img src={mapPin} alt="Work Location" />
              { `${project?.office_and_worktype_information}` }
            </div>
          ) : ''}
        { project?.days_of_travel && project?.travel_locations
          ? (
            <div className="availability-text">
              <img src={airplane} alt="Travel" />
              {`Travel Requirements - Travel to ${project?.travel_locations} ${project?.days_of_travel} day(s) per month`}
            </div>
          ) : ''}
        {
          !project?.days_of_travel && project?.travel_locations
            ? (
              <div className="availability-text">
                <img src={airplane} alt="Travel" />
                { `Travel Requirements - ${project?.travel_locations}` }
              </div>
            ) : ''
        }
        { submitted
          ? '✅ Accepted'
          : (
            <label htmlFor="availability-checkbox" className="availability-checkbox-label">
              <input
                type="checkbox"
                id="availability-checkbox"
                onChange={handleToggleCheckbox('availability')}
              />
              I understand
            </label>
          )}
        {submitAttempted && !checkboxes.availability
          && (
          <div className="warning-text">
            Please acknowledge before continuing to the next step
          </div>
          )}

        {isHybridOrInOffice
          && (
          <Fragment>
            <h5 className="uppercase-demibold mt-4">Hybrid or In Office </h5>
            {submitted
              ? (
                <div className="availability-text mt-3">
                  <img src={mapPin} alt="Work Location" />
                  {`Consultant Location: ${location || 'Not specified'}`}
                </div>
              )
              : (
                <Fragment>
                  <div className="mt-3">
                    <h6>Your Location</h6>
                    <div className="mt-2">
                      <Geosuggest
                        initialValue={location}
                        suggestItemClassName="geosuggest-font"
                        inputClassName="input-base"
                        placeholder="Type your current location"
                        onSuggestSelect={(obj) => obj && handleTextChange('location')(obj.label)}
                      />
                    </div>
                  </div>
                </Fragment>
              )}
            {submitted
              ? (
                <div className="availability-text mb-3">
                  <img src={airplane} alt="Travel" />
                  {openToRelocation ? '✅  I am open to Relocation' : '❌  I am not open to Relocation'}
                </div>
              )
              : (
                <div className="d-flex flex-column mb-3 mt-2">
                  <label
                    htmlFor="open-to-relocation"
                    className="custom-checkbox-container"
                  >
                    <input
                      type="checkbox"
                      id="open-to-relocation"
                      name="open-to-relocation"
                      className="checkbox-box"
                      checked={openToRelocation}
                      onChange={handleOpenToggleCheckbox}
                    />
                    <span className="checkmark" />
                    <span className={`checkbox-text ${checkboxes?.openToRelocation ? 'active' : ''}`}>
                      I am open to Relocation.
                    </span>
                  </label>
                  {submitAttempted && location === '' && (
                  <div className="warning-text">
                    Please enter your current location and check the box if you are open to relocation.
                  </div>
                  )}
                </div>
              )}
          </Fragment>
          )}

        { project?.employment_type === 'consulting'
          ? this.renderHourlyRateSection() : ''}

        { project?.employment_type === 'consulting'
          ? this.renderTaxReporting() : this.renderWorkAuthorization() }
        { submitAttempted && missingRequiredExpertise
          && (
          <div className="warning-text">
            <br />
            You must have the required expertise in order to submit this application.
            <br />
          </div>
          )}
      </div>
    );
  }
}

InterestDetails.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    consultant_name: PropTypes.string,
    avg_time_required_range: PropTypes.string,
    duration_range: PropTypes.string,
    days_of_travel: PropTypes.number,
    approximate_start_date_local: PropTypes.string,
    remote_preferred_location: PropTypes.string,
    office_days: PropTypes.number,
    work_location: PropTypes.string,
    office_location: PropTypes.string,
    responsibilities: PropTypes.arrayOf(PropTypes.string),
    matching_priority_tags: PropTypes.shape({}),
    matching_preferred_tags: PropTypes.shape({}),
    missing_priority_tags: PropTypes.shape({}),
    missing_preferred_tags: PropTypes.shape({}),
    consultant_take_home_minimum: PropTypes.number,
    consultant_take_home_maximum: PropTypes.number,
  }).isRequired,
  csrfToken: PropTypes.string.isRequired,
  uploadResumeUrl: PropTypes.string,
  resume: PropTypes.shape({}),
  missingRequiredExpertise: PropTypes.bool,
  handleUpdateResume: PropTypes.func,
  handleToggleCheckbox: PropTypes.func,
  handleOpenToggleCheckbox: PropTypes.func,
  handleTextChange: PropTypes.func,
  profilePath: PropTypes.string,
  submitAttempted: PropTypes.bool,
  submitted: PropTypes.bool.isRequired,
  requestedHourlyRate: PropTypes.string,
  checkboxes: PropTypes.shape({}).isRequired,
  repView: PropTypes.bool,
};

InterestDetails.defaultProps = {
  uploadResumeUrl: '',
  resume: {},
  missingRequiredExpertise: false,
  handleUpdateResume: () => {},
  handleToggleCheckbox: () => {},
  handleTextChange: () => {},
  handleOpenToggleCheckbox: () => {},
  profilePath: '',
  submitAttempted: false,
  requestedHourlyRate: '',
  repView: false,
};

export default InterestDetails;
